"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AUTOMATED_PUBLISHING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUTOMATED_PUBLISHING;
  }
});
Object.defineProperty(exports, "BRAND_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BRAND_TRACKING;
  }
});
Object.defineProperty(exports, "CONTENT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONTENT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CUSTOMER_ENGAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMER_ENGAGEMENT;
  }
});
Object.defineProperty(exports, "MULTI_ACCOUNT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MULTI_ACCOUNT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "MULTI_USER_COLLABORATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MULTI_USER_COLLABORATION;
  }
});
Object.defineProperty(exports, "PLATFORM_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PLATFORM_INTEGRATION;
  }
});
Object.defineProperty(exports, "POST_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.POST_SCHEDULING;
  }
});
Object.defineProperty(exports, "REPORTING_ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.REPORTING_ANALYTICS;
  }
});
Object.defineProperty(exports, "SOCIAL_ADS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_ADS;
  }
});
Object.defineProperty(exports, "SOCIAL_CAMPAIGNS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_CAMPAIGNS;
  }
});
Object.defineProperty(exports, "SOCIAL_ENGAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_ENGAGEMENT;
  }
});
Object.defineProperty(exports, "SOCIAL_MEDIA_MONITORING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_MEDIA_MONITORING;
  }
});
Object.defineProperty(exports, "SOCIAL_SHARING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_SHARING;
  }
});
Object.defineProperty(exports, "SOFTWARE_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOFTWARE_INTEGRATION;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Social.js
// module id = 582
// module chunks = 209 210 211 212 213